import { Component, OnInit } from '@angular/core';
import { MemberCard, MemberCardQuery, MemberDetails, MemberQuery, Barcode, BarcodeService, BarcodeQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.scss'],
})
export class MemberCardComponent implements OnInit {
  memberCard$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  member$: Observable<MemberDetails | undefined>;
  barcode$: Observable<Barcode>;
  populations = Populations;
  productcode = ProductCode;

  constructor(
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private modalService: NgbModal,
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
  }

  openChildBarcode(modal: any) {
    this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'child-barcode-modal',
      centered: true,
    });
  }
}
